module.exports = __webpack_public_path__ + "static/vitusapotek-c42c02cddff42a010bfabc29d5c6226b.png";